import { Injectable } from '@angular/core';
import { ApiBaseService } from './api.base.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class MeetingSchedulerService extends ApiBaseService {
  constructor(public http: HttpClient) {
    super(http, '/meeting-scheduler');
  }

  getMeetingScheduler(params: any) {
    return this.http.get<any>(`${environment.apiUrl}/external/get-meeting`, {
        params: params,
      });
  }

  submitMeetingScheduler(body: any): Observable<any> {
    return this.http.post(`${environment.apiUrl}/external/create-meeting`, body);
  }
  getMeetingDetails(params: { id: string, cancelEvent: string }): Observable<any> {
    return this.http.get<any>(`${environment.apiUrl}/external/get-meeting-details`, { 
      params: {
        id: params.id,
        cancelEvent: params.cancelEvent
      }
    });
  }

  rescheduleMeeting(params: { meetingId: string, scheduleId: string, timeSlot: any, formData: any }): Observable<any> {
    return this.http.post<any>(`${environment.apiUrl}/external/reschedule-meeting`, params);
  }
  
  cancelMeeting(params: { meetingId: string, cancelId: string,recaptchaToken:string,recaptchaAction:string, message?: string,recaptchaVersion:any }): Observable<any> {
    return this.http.post<any>(`${environment.apiUrl}/external/cancel-meeting`, params);
  }
}
